module.exports = __webpack_public_path__ + "img/NoGreatSatisfaction.91bfd993.png";